import Vue from 'vue';

import VueI18n from 'vue-i18n';
import ukTranslations from '@/i18n/uk.js';
import enTranslations from '@/i18n/en.js';
import ruTranslations from '@/i18n/ru.js';

import VCalendar from 'v-calendar';

import UIkit from '@qrwaiter/qrwaiter-ui-kit';

import '@qrwaiter/qrwaiter-ui-kit/dist/qrwaiter-ui-kit.css';

import App from './App.vue';
import router from './router';
import store from './store';

import VueMask from 'v-mask';

import moment from 'moment';

import VueMeta from 'vue-meta';

import ScrollInverse from '@/services/scrollinverse';

import PortalVue from 'portal-vue';

import Header from './components/Header2.vue';
import PageContainer from './components/PageContainer.vue';
import IQOS from './components/IQOS.vue';
import IQOSActions from './components/IQOSActions.vue';
import IQOSTable from './components/IQOSTable.vue';
import IQOSImageActions from './components/IQOSImageActions.vue';
import IQOSModeToggle from './components/IQOSModeToggle.vue';
import IQOSToggle from './components/IQOSToggle.vue';
import IQOSModeBadge from './components/IQOSModeBadge.vue';
import IQOSHorizontalScroll from './components/IQOSHorizontalScroll.vue';
import IQOSTooltip from './components/IQOSTooltip.vue';
import IQOSHorizontalScrollWithActions from './components/IQOSHorizontalScrollWithActions.vue';

import IQOSModal from './components/modals/IQOSModal.vue';
import DangerConfirmModal from './components/modals/DangerConfirmModal.vue';
import WhiteModal from './components/modals/WhiteModal.vue';
import WhiteTooltipMenu from './components/base/WhiteTooltipMenu.vue';
import WhiteIQOSActions from './components/base/WhiteIQOSActions.vue';

import WhiteIQOS from '@/components/base/WhiteIQOS.vue';

Vue.use(VueMask);
Vue.use(VueI18n);
Vue.use(UIkit, {
  preloadIcons: [
    'trash',
    'chevron-right',
    'arrow-left',
    'x',
    'grid',
    'download-bold',
    'shop',
    'plus',
    'check',
    'dot',
    'check-verified',
    'check-circle-filled',
    'marker-pin',
    'timer',
    'bookmark-filled',
    'phone-bold',
    'bar-chart-02',
    'activity-heart',
    'users',
    'settings-02',
    'book-open',
    'phone',
    'file',
    'scooter',
    'puzzle',
    'pencil',
  ],
});
Vue.component('Header', Header);
Vue.component('PageContainer', PageContainer);
Vue.component('IQOS', IQOS);
Vue.component('IQOSActions', IQOSActions);
Vue.component('IQOSTable', IQOSTable);
Vue.component('IQOSToggle', IQOSToggle);
Vue.component('IQOSImageActions', IQOSImageActions);
Vue.component('IQOSModeToggle', IQOSModeToggle);
Vue.component('IQOSModeBadge', IQOSModeBadge);
Vue.component('IQOSHorizontalScroll', IQOSHorizontalScroll);
Vue.component(
  'IQOSHorizontalScrollWithActions',
  IQOSHorizontalScrollWithActions
);
Vue.component('IQOSModal', IQOSModal);
Vue.component('DangerConfirmModal', DangerConfirmModal);
Vue.component('IQOSTooltip', IQOSTooltip);
Vue.component('WhiteIQOS', WhiteIQOS);
Vue.component('WhiteModal', WhiteModal);
Vue.component('WhiteTooltipMenu', WhiteTooltipMenu);
Vue.component('WhiteIQOSActions', WhiteIQOSActions);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VCalendar);
Vue.use(PortalVue);

import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

Vue.use(Donut);

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.config.productionTip = false;

const messages = {
  ua: ukTranslations,
  en: enTranslations,
  ru: ruTranslations,
  uk: ukTranslations,
};

ScrollInverse.init();

moment.locale('uk');

Vue.filter('formatDatetime', (val) => {
  return moment(val).format('DD.MM.YYYY HH:mm');
});

Vue.filter('formatDate', (val) => {
  return moment(val).format('DD.MM.YYYY');
});

Vue.filter('formatTime', (val) => {
  return moment(val).format('HH:mm');
});

const i18n = new VueI18n({
  locale: 'uk',
  messages,
});

router.afterEach((to, from) => {
  ScrollInverse.unlock();
  window.Intercom('update');

  const to_name = to.name;
  const to_i18n = i18n.te(`navbar.${to_name}`)
    ? i18n.t(`navbar.${to_name}`)
    : null;

  if (!to_i18n) {
    window.document.title = `QRWaiter`;
  } else {
    window.document.title = `${to_i18n} - QRWaiter`;
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
